import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import cn from 'classnames';
import './ReferredCreator.scss';

import { getReferringUser as getReferringUserAPI } from '../../APIClient/users';
import { addEvent } from '../../APIClient/events';

import Image from '../../Components/General/Image';
import { getInitialsForUser } from '../../Helpers/formatting';

const ReferredCreator = () => {
  const params = useParams();
  const username = params.username;

  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const referralRoute = user?.Brand_id ? `/apply/creator?referring_brand=${user.Brand_id}` : `/apply/creator?referral=${username}`;

  useEffect(() => {
    setIsLoading(true);

    const loadCreator = async () => {
      try {
        const respPromise = getReferringUserAPI(username);
        const minWaitPromise = new Promise(resolve => setTimeout(resolve, 1_000));
        const [resp] = await Promise.all([respPromise, minWaitPromise]);

        addEvent(`Referral - Referral Page Sign Up View`, { user: resp?.user?.name });
        setUser(resp.user);
      } catch (error) {
        console.error(error);
        window.ALERT.error('No user could be found with your referral, please double check your referral link.');
      } finally {
        setIsLoading(false);
      }
    };

    loadCreator();
  }, [username]);

  return (
    <div className='referred-creator-outer'>
      <div className='referred-creator-inner'>
        <div className='referred-creator-header-outer'>
          <div className={cn('referred-creator-header-inner', { isLoading })}>
            <Image
              src={user?.image || user?.mobileBadgeImage}
              className='referred-creator-header-image'
              failedText={getInitialsForUser(user) || 'S'}
              useGenericFailedStyles
            />
            <h1>
              <span>Join {user?.name || 'Other Creators'}</span>
              <span>on ShopMy</span>
            </h1>
            <h2>
              ShopMy is a platform that lets creators monetize your influence on other social media platforms by creating affiliate links and
              partnering directly with industry leading brands. You can use ShopMy on your desktop or via our iOS app.
            </h2>

            <div className='referred-creator-links'>
              <a href={referralRoute} className='referred-creator-link-large'>
                Apply Now
              </a>
              <a href='/home/brands' className='referred-creator-link-small'>
                I am a Brand
              </a>
            </div>
          </div>
        </div>

        <div className='referred-creator-body-outer'>
          <div className='referred-creator-body-inner'>
            <h3 className='referred-creator-body-header'>You're a fit for ShopMy if you</h3>

            <div className='referred-creator-body-card-container'>
              <div className='referred-creator-body-card'>
                <h4 className='referred-creator-body-card-title'>Have an engaged, loyal audience</h4>
                <h5 className='referred-creator-body-card-text'>
                  We've seen that it doesn't matter how large your audience is, only how in tune your audience is with your content.
                </h5>
                <img
                  src='https://askemma-static-public.s3.us-east-2.amazonaws.com/Onboarding/ReferredCreator/engaged_loyal_audience.png'
                  className='referred-creator-body-card-image'
                  alt='Have an engaged, loyal audience'
                />
              </div>

              <div className='referred-creator-body-card'>
                <h4 className='referred-creator-body-card-title'>Want to grow via affiliate marketing</h4>
                <h5 className='referred-creator-body-card-text'>Link to thousands of your favorite brands and grow your affiliate presence.</h5>
                <img
                  src='https://askemma-static-public.s3.us-east-2.amazonaws.com/Onboarding/ReferredCreator/grow_via_affiliate.png'
                  className='referred-creator-body-card-image'
                  alt='Are looking to grow via affiliate'
                />
              </div>

              <div className='referred-creator-body-card'>
                <h4 className='referred-creator-body-card-title'>Regularly post shoppable content</h4>
                <h5 className='referred-creator-body-card-text'>
                  Linking to your favorite products on a consistent daily, weekly, or monthly basis.
                </h5>
                <img
                  src='https://askemma-static-public.s3.us-east-2.amazonaws.com/Onboarding/ReferredCreator/regularly_post_shoppable_content.png'
                  className='referred-creator-body-card-image'
                  alt='Regularly post shoppable content'
                />
              </div>
            </div>

            <div className='referred-creator-links'>
              <a href={referralRoute} className='referred-creator-link-large'>
                Apply Now
              </a>
              <a href='/home/brands' className='referred-creator-link-small'>
                I am a Brand
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferredCreator;
